import { MessageState, RESET_SENDER } from './types'


export const resetSender = () => {
    return { type: RESET_SENDER }
}